// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

var Raw = {};

function parse(value) {
  var value$1 = value.workerShiftTipAmounts;
  var value$2 = value$1.nodes;
  return {
          workerShiftTipAmounts: {
            nodes: value$2.map(function (value) {
                  if (!(value == null)) {
                    return {
                            amountCents: value.amountCents,
                            id: value.id
                          };
                  }
                  
                })
          }
        };
}

function serialize(value) {
  var value$1 = value.workerShiftTipAmounts;
  var value$2 = value$1.nodes;
  var nodes = value$2.map(function (value) {
        if (value === undefined) {
          return null;
        }
        var value$1 = value.id;
        var value$2 = value.amountCents;
        return {
                amountCents: value$2,
                id: value$1
              };
      });
  var workerShiftTipAmounts = {
    nodes: nodes
  };
  return {
          workerShiftTipAmounts: workerShiftTipAmounts
        };
}

function verifyArgsAndParse(_CommonTypes_WorkerShift_TipAmount, value) {
  return parse(value);
}

function verifyName(param) {
  
}

function tToR(param) {
  var partial_arg = Curry._2(Relude_Array.foldLeft, (function (prim, prim$1) {
          return prim + prim$1 | 0;
        }), 0);
  return Relude_Option.fold(/* TipAmountMissing */0, (function (param) {
                return Relude_Globals.$great$great(partial_arg, (function (amount) {
                              if (amount !== 0) {
                                return /* EarnedTips */{
                                        _0: amount
                                      };
                              } else {
                                return /* NoTipsEarned */1;
                              }
                            }), param);
              }), Relude_Option.reject(Relude_Array.isEmpty)(Relude_Option.pure(Relude_Array.mapOption((function (param) {
                            return Relude_Option.map((function (param) {
                                          return param.amountCents;
                                        }), param);
                          }), param.workerShiftTipAmounts.nodes))));
}

var query = "fragment CommonTypes_WorkerShift_TipAmount on WorkerShift   {\nworkerShiftTipAmounts  {\nnodes  {\namountCents  \nid  \n}\n\n}\n\n}\n";

exports.Raw = Raw;
exports.query = query;
exports.parse = parse;
exports.serialize = serialize;
exports.verifyArgsAndParse = verifyArgsAndParse;
exports.verifyName = verifyName;
exports.tToR = tToR;
/* Relude_Array Not a pure module */
